import { MessageSquare, Trash2, ZoomIn } from "lucide-react"

import { IconButton, TooltipProvider } from "@/components/ui/icon-button"

export function IconButtonPreviewRoute(): JSX.Element {
  return (
    <TooltipProvider>
      <div className="mx-auto max-w-4xl px-8.5 py-11">
        <header className="mb-8">
          <div className="font-id text-eyebrow uppercase tracking-[0.16em] text-text-3">
            Primitive
          </div>
          <h1 className="mt-1 text-display text-text">IconButton</h1>
        </header>

        <Section title="Variants">
          <IconButton variant="default" label="Open messages" icon={<MessageSquare />} />
          <IconButton variant="ghost" label="Zoom in" icon={<ZoomIn />} />
          <IconButton variant="destructive" label="Delete" icon={<Trash2 />} />
        </Section>

        <Section title="Sizes">
          <IconButton size="sm" label="Zoom in (small)" icon={<ZoomIn />} />
          <IconButton size="md" label="Zoom in (medium)" icon={<ZoomIn />} />
        </Section>

        <Section title="Disabled">
          <IconButton disabled label="Zoom in" icon={<ZoomIn />} />
        </Section>

        <Section title="With count (tooltip via label)">
          <IconButton label="Open messages" icon={<MessageSquare />} count={3} />
        </Section>
      </div>
    </TooltipProvider>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }): JSX.Element {
  return (
    <section className="mb-8">
      <h2 className="mb-3.5 font-id text-caption uppercase tracking-[0.16em] text-text-3">
        {title}
      </h2>
      <div className="flex flex-wrap items-center gap-3.5">{children}</div>
    </section>
  )
}
